export const useSettingsStore = defineStore('SettingsStore', () => {

  //region Current Time
  const runtimeConfig = useRuntimeConfig();
  const currentTimestampOffsetInternal = ref(0);

  const setCurrentTimestampOffset = (milliseconds: number) => {
    currentTimestampOffsetInternal.value = milliseconds;
  }

  const currentTimestampOffset = computed(() => {
    return runtimeConfig.public.allowTimeOverride === 'true'? currentTimestampOffsetInternal.value : 0;
  })

  //endregion

  //region App components visibility/styling

  const hideFooter = ref(false);

  //endregion


  const selectedCameraId = ref<string | null>(null);

  const openLeadAfterScan = ref(true);

  return {
    // Current time
    currentTimestampOffsetInternal,
    currentTimestampOffset,
    setCurrentTimestampOffset,

    // Components
    hideFooter,

    selectedCameraId,
    openLeadAfterScan,
  }
}, {
  persist: {
    pick: ['currentTimestampOffsetInternal', 'selectedCameraId', 'openLeadAfterScan']
  },
},)
